import View from '@shared/components/layout-default/layout-default-router-view';

export const mailer = [
  {
    path: 'mailer',
    component: View,
    children: [
      {
        path: '',
        redirect: {
          name: 'mailer.mailing.index',
          params: {
            type: 'sms'
          }
        }
      },

      {
        path: 'mailings',
        component: View,
        children: [
          {
            path: '',
            name: 'mailer.mailing.index',
            redirect: {
              name: 'mailer.mailing.type',
              params: {
                type: 'sms'
              }
            }
          },

          {
            path: ':type(sms)',
            name: 'mailer.mailing.type',
            component: () =>
              import(
                /* webpackChunkName: 'mailer-mailings' */
                '@mailer/pages/mailings-list-page'
              ),
            meta: {
              title: {
                code: 'mailer.breadcrumb.mailing.index'
              }
            }
          },

          {
            path: 'new',
            name: 'mailer.mailing.create',
            component: () =>
              import(
                /* webpackChunkName: 'mailer-mailings' */
                '@mailer/pages/mailings-create-page'
              ),
            meta: {
              title: {
                code: 'mailer.breadcrumb.mailing.create'
              }
            }
          }
        ]
      },
      {
        path: 'senders',
        name: 'mailer.sender.index',
        component: () =>
          import(
            /* webpackChunkName: 'mailer-senders' */
            '@mailer/pages/senders-list-page'
          ),
        meta: {
          title: {
            code: 'mailer.breadcrumb.sender.index'
          }
        }
      },

      {
        path: 'messages',
        component: View,
        meta: {
          permissions: ['service_incoming_sms_is_allowed']
        },
        children: [
          {
            path: '',
            component: () =>
              import(
                /* webpackChunkName: 'mailer-messages' */
                '@mailer/pages/messages-page'
              ),
            children: [
              {
                path: '',
                name: 'mailer.message.index',
                component: () =>
                  import(
                    /* webpackChunkName: 'mailer-messages' */
                    '@mailer/pages/messages-list-page'
                  ),
                meta: {
                  title: {
                    code: 'mailer.breadcrumb.message.index'
                  }
                }
              },

              {
                path: 'settings',
                name: 'mailer.message.setting',
                component: () =>
                  import(
                    /* webpackChunkName: 'mailer-messages' */
                    '@mailer/pages/messages-settings-page'
                  ),
                meta: {
                  title: {
                    code: 'mailer.breadcrumb.message.setting'
                  }
                }
              }
            ]
          }
        ]
      },
      {
        path: 'stats',
        component: View,
        children: [
          {
            path: '',
            name: 'mailer.stats.index',
            redirect: {
              name: 'mailer.stats.type',
              params: {
                type: 'general'
              }
            }
          },
          {
            path: ':type(general|detailed)',
            name: 'mailer.stats.type',
            component: () =>
              import(
                /* webpackChunkName: 'mailer-mailings' */
                '@mailer/pages/mailings-stats-page'
              ),
            meta: {
              title: {
                code: 'shared.breadcrumb.stats.title'
              }
            }
          }
        ]
      }
    ]
  }
];
